import React from 'react'
import { formatText, getCountryStorage, isAU } from '../common';
//import { APEXTableData } from '../commercials/data';
import { formatBillingDate, getCommercialData } from '../earnings/helpers';
import "../earnings/commercials.scss"



function FeesMonth(props) {
    
    let data = getCommercialData()[0] //APEXTableData[0]
    const renderHeader = () => {
        return (
            <div className='d-flex justify-content-between header-container'>
                <div className='d-flex flex-wrap col-6'>
                    <strong><h5>{"Usage-Based SaaS Platform Fees Invoice" }</h5></strong>
                    <span>Billing Period {`${formatBillingDate(data["start period"])} to ${formatBillingDate(data["end period"])}`}</span>
                    <span>Statement Reference - {data["invoiceNumber"]}</span>
                </div>                
            </div>
        )
    }

    const renderdoubleInput = (label, input1 = "", input2 = "", className = "") => {
        return (
            <div className={"d-flex flex-row flex-wrap p-0 col-12 justify-content-between " + className}>
                <label className="mb-1 bb-form-input-label col-4 text-right pt-2 bb-form-dsp-label">{label}</label>
                <div className="col-8 row ">
                    <span className="form-control fake-input mb-2  mr-2 small text-right">{input1}</span>
                    {input2 ? <span className=" form-control fake-input mb-2 small text-right">{input2}</span> : null}
                </div>
            </div>

        )

    }

    const renderFourInput = (label, input1 = "", input2 = "", input3 = "", input4="", className = "") => {
        return (
            <div className={"d-flex flex-row flex-wrap p-0 col-12 justify-content-between " + className}>
                <label className="mb-1 bb-form-input-label col-4 text-right pt-2 bb-form-dsp-label">{label}</label>
                <div className="col-8 row ">
                    <span className="form-control fake-input mb-2  mr-2 small text-right">{input1}</span>
                    {input2 ? <span className=" form-control fake-input mb-2 mr-2 small text-right">{input2}</span> : null}
                    {input3 ? <span className=" form-control fake-input mb-2 mr-2 small text-right">{input3}</span> : null}
                    {input4 ? <span className=" form-control fake-input mb-2 small text-right">{input4}</span> : null}
                </div>
            </div>

        )

    }

    const renderInput = (label, input) => {
        return (
            <div className="d-flex flex-row flex-wrap p-0 col-12 justify-content-between">
                <label className="mb-1 bb-form-input-label col-4 text-right pt-2 bb-form-dsp-label">{label}</label>
                <div className="col-8 row">
                    <span className="form-control fake-input mb-2  small text-right">{input}</span>
                </div>
            </div>
        )
    }

    const fakeData = { liteImps: "2,291,667",
                        premiumImps: "1,750,000",
                       advancedImps: "1,100,000",
                       skinImps: "471,429",

                       liteSpend: "$27,500",
                       premiumSpend: "$38,500",
                       advancedSpend: "$27,500",
                       skinSpend: "$16,500",
                       totalFee: "31,081",
                       totalPercentage: "28.26%",
                       totalFeeWithSupport: "41,081",
    }
    return (
        <div className='fee'>
            {renderHeader()}
            <div className='d-flex col-12 flex-wrap mt-5'>
                <div className="d-flex flex-row flex-wrap p-0 col-12 justify-content-between">
                    <label className="mb-1 bb-form-input-label col-auto pt-2 bb-form-dsp-label"></label>
                    <div className="col-md-8 row ">
                        {isAU() ? <span className="mb-2  mr-2  bb-font_12px fake-input small">{formatText[0]} Format @ ${'12.00'}</span> : null }
                        <span className="mb-2  mr-2  bb-font_12px fake-input small">{formatText[1]} Format @ ${isAU() ? '22.00' : '18.00'}</span>
                        <span className=" mb-2 mr-2 bb-font_12px fake-input small">{formatText[2]} Format @ ${isAU() ? '25.00' : '21.00'}</span>
                        {isAU() ? <span className=" mb-2 bb-font_12px fake-input small">{formatText[3]} Format @ ${'35.00'}</span> : null}
                    </div>
                </div>

                {isAU() ? renderFourInput("Ads IMPs Served",fakeData["liteImps"], fakeData["premiumImps"], fakeData["advancedImps"], fakeData["skinImps"])
                : renderdoubleInput("Ads IMPs Served",data["premiumImps"], data["advancedImps"])    
                }
                {isAU() ? renderFourInput("Spend by Ad Format",fakeData["liteSpend"], fakeData["premiumSpend"], fakeData["advancedSpend"], fakeData["skinSpend"])
                : renderdoubleInput("Spend by Ad Format", `$${data["premiumSpend"]}`, `$${data["advancedSpend"]}`)}

                {renderInput("Billings Through Platform", `$${data["totalSpend"]}`)}

                <div className='border d-flex flex-wrap mt-2'>
                    {renderdoubleInput("Big Ads Usage-Based Saas %", isAU() ? fakeData["totalPercentage"] : data["totalPercentage"]) }
                    {renderdoubleInput("Big Ads Usage-Based Saas Fees", `$${ isAU() ? fakeData["totalFee"] : data["totalFee"]}`)}
                    {renderdoubleInput("Support - Foundation Package", `$${data["supportFee"]}`)}
                    {renderdoubleInput("Total Big Ads Usage-Based Saas Fees", `$${isAU() ? fakeData["totalFeeWithSupport"] : data["totalFeeWithSupport"]}`, false, "fee-grey")}
                </div> 

              {/*   <div className="d-flex flex-row justify-content-end w-100 m-3 ">
                    <button type="button" onClick={() => { pushLocation("/fees") }} className="bb-button" disabled={false}>Close</button>
                </div> */}

            </div>


        </div>
    )
}

export default (FeesMonth);
